import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  store,
  routes: [
    {
      path: '*',
      name: '404',
      component: () => import('@/components/404')
    },
    {
      path: '/',
      name: 'main',
      component: () => import('@/components/main')
    },
    {
      path: '/bookings',
      name: 'bookings',
      component: () => import('@/components/bookings')
    },
    {
      path: '/staff',
      name: 'staff',
      component: () => import('@/components/staff')
    },
    {
      path: '/objects',
      name: 'objects',
      component: () => import('@/components/objects')
    },
    {
      path: '/locations',
      name: 'locations',
      component: () => import('@/components/locations')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/login')
    },
    {
      path: '/reset_password',
      name: 'reset_password',
      component: () => import('@/components/reset_password')
    },
    {
      path: '/reg',
      name: 'reg',
      component: () => import('@/components/reg')
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/components/help')
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('@/components/notifications')
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('@/components/history')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/components/settings')
    },
    {
      path: '/howto',
      name: 'howto',
      component: () => import('@/components/howto')
    },
    {
      path: '/bookkeeping',
      name: 'bookkeeping',
      component: () => import('@/components/bookkeeping')
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: () => import('@/components/statistics')
    }
  ]
})

router.beforeEach(
  (to, from, next) => {
    if (to.path === '/login' || to.path === '/reset_password' || to.path === '/reg') {
      next()
    } else {
      if (localStorage.setToken === undefined) {
        next('/login')
      } else {
        next()
      }
    }
  }
)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js